import i18next from 'i18next';

i18next.addResources('es', 'login', {
  title: 'Iniciar sesión',
  username: 'Usuario',
  password: 'Contraseña',
  submit: 'Ingresar',
  submitting: 'Ingresando…',
  error: 'Usuario o contraseña incorrectos.'
});

i18next.addResources('en', 'login', {
  title: 'Sign in',
  username: 'Username',
  password: 'Password',
  submit: 'Sign in',
  submitting: 'Signing in…',
  error: 'Incorrect username or password.'
});

i18next.addResources('pt', 'login', {
  title: 'Entrar',
  username: 'Usuário',
  password: 'Senha',
  submit: 'Entrar',
  submitting: 'Entrando…',
  error: 'Usuário ou senha incorretos.'
});
